module.exports = __webpack_public_path__ + "img/3-1.16ce6256.png";